<template>
  <button
    type="button"
    class="flex items-center gap-2 xl:gap-4 w-full px-3 xl:pl-12"
    @click="props.params.onClick"
  >
    <span
      class="rounded-full border border-current flex items-center justify-center shrink-0 font-bold w-7 h-7 leading-none"
    >
      <template v-if="params.isLocked">
        <LockClosedIcon class="w-4 h-4" />
      </template>
      <template v-else-if="params.status === status.cancelled">
        <XMarkIcon class="w-4 h-4" />
      </template>
      <template v-else-if="params.status === status.bagged">
        <CheckIcon class="w-4 h-4" />
      </template>
      <template v-else>
        <BuildingStorefrontIcon
          v-if="params.data.delivery_method === FULFILLMENT_TYPES.IN_STORE"
          class="w-4 h-4"
        />
        <ShoppingBagIcon
          v-else-if="params.data.delivery_method === FULFILLMENT_TYPES.PICK_UP"
          class="w-4 h-4"
        />
        <TruckIcon
          v-else-if="params.data.delivery_method === FULFILLMENT_TYPES.DELIVERY"
          class="w-4 h-4"
        />
      </template>
    </span>
    <span class="flex flex-col text-left">
      <span class="font-semibold">
        {{ params.status }}
      </span>
      <span class="text-xxs font-medium">
        {{ needsPackingAt }}
      </span>
    </span>
  </button>
</template>

<script setup>
import { DateTime } from 'luxon'
import { LockClosedIcon, CheckIcon, XMarkIcon } from '@heroicons-2/vue/24/outline'
import { FULFILLMENT_STATUS as status } from '@/Composables/Fulfillment/constants'
import { BuildingStorefrontIcon, TruckIcon, ShoppingBagIcon } from '@heroicons-2/vue/24/outline'
import { FULFILLMENT_TYPES } from '@/constants'

/**
 * @typedef {Object} FulfillmentCellParams
 * @property {string} status - The fulfillment status of the order
 * @property {boolean} isLocked - Indicates if the order is locked
 * @property {Object} data - The order data
 * @property {number} data.priority - The priority of the order
 * @property {string} data.needs_packed_at - The ISO date string when the order needs to be packed
 * @property {Function} onClick - The function to call when the cell is clicked
 */
const props = defineProps({
  /** @type {FulfillmentCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const needsPackingAtDateTime = DateTime.fromISO(props.params.data.needs_packed_at)

const needsPackingAt = needsPackingAtDateTime.toRelative({
  style: 'short'
})
</script>
